<template>
  <m-card
    no-padding
    list
  >
    <template
      v-for="action in gridPageService.createActions"
      :key="action.gridPageType"
    >
      <m-dropdown
        v-if="action.children"
        block
        placement="topRight"
        trigger="hover"
        :title="action.label"
      >
        <m-card-item
          :icon="action.icon"
          :loading="loading === action.gridPageType"
        >
          {{ action.label }}
          <template #right>
            <m-icon
              type="right"
              size="11"
              :color="$colors.grey.lighten2"
            />
          </template>
        </m-card-item>
        <template #overlay>
          <m-card
            no-padding
            list
            :style="{ minWidth: '14rem' }"
          >
            <m-card-item
              v-for="child in action.children"
              :key="child.key"
              :icon="child.icon"
              :loading="loading === child.key"
              @click="add(child)"
            >
              {{ child.label }}
            </m-card-item>
          </m-card>
        </template>
      </m-dropdown>
      <m-card-item
        v-else
        :icon="action.icon"
        :loading="loading === action.gridPageType"
        @click="add(action)"
      >
        {{ action.label }}
      </m-card-item>
    </template>
  </m-card>
</template>

<script setup>
import useGridPage from '@/composables/grid-page/grid-page';
import useInlineEditing from '@/composables/inline-editing';
import useSnackBar from '@/composables/snackbar';
import { gridPageType } from 'shared/constants.json';
import { logCatch } from '@/lib/logger/logger';
import { ref } from 'vue';

const emit = defineEmits(['close']);

const props = defineProps({
  gridRow: {
    type: Object,
    required: true,
  },
  gridPage: {
    type: Object,
    required: true,
  },
});

const inlineEditingSvc = useInlineEditing();
const snackBar = useSnackBar();

const gridPageService = useGridPage();

const loading = ref('');
function add(action) {
  loading.value = action.key ?? action.gridPageType;
  gridPageService.addGridPageTile({
    type: action.gridPageType,
    gridPageRow: { uid: props.gridRow.uid, gridPage: { uid: props.gridPage.uid } },
    ...(action.tileArgs ?? {}),
  }).then((res) => {
    if (![gridPageType.singleGoal, gridPageType.iframe, gridPageType.media].includes(action.gridPageType)) {
      inlineEditingSvc.set(res.uid);
    }
  }).catch(logCatch(() => { snackBar.error(); }))
    .finally(() => {
      loading.value = '';
    });
  emit('close');
}

</script>
